import type { ReactNode } from 'react';
import { NJHeading, NJIcon, NJText } from '@engie-group/fluid-design-system-react';

export function RatioSectionHeader({ number, title, icon, children }: {
  number: number; title: string; icon: string; children?: ReactNode;
}) {
  return (
    <header className={`pcv3-ratios-header pcv3-ratios-section-header pcv3-ratios-section-${number}`}>
      <NJText className="pcv3-ratios-number">{number}</NJText>
      <NJIcon name={icon} />
      <NJHeading as="h2" scale="sm">{title}</NJHeading>
      <div className="pcv3-ratios-header-actions">{children}</div>
    </header>
  );
}
